if (!customElements.get('reference-header')) {
  customElements.define('reference-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile = this.querySelector('[data-header-mobile]');
      this.mobileToggle = this.mobile?.querySelector('summary');
      this.disclosures = [...this.querySelectorAll('details')];
      const listen = (element, event, handler, options = {}) => element?.addEventListener(event, handler, { ...options, signal });
      listen(this, 'keydown', event => {
        if (event.key !== 'Escape') return;
        const closest = event.target.closest('details[open]');
        const target = closest || this.querySelector('details[open]');
        if (target) { event.preventDefault(); target.open = false; target.querySelector('summary').focus(); }
      });
      listen(this, 'focusout', event => {
        if (!this.contains(event.relatedTarget)) this.closeAll();
      });
      this.disclosures.forEach(details => {
        listen(details, 'toggle', () => {
          if (details === this.mobile) {
            this.mobileToggle.setAttribute('aria-label', details.open ? this.dataset.closeLabel : this.dataset.openLabel);
          }
          if (details.open) {
            this.disclosures.forEach(other => {
              if (other !== details && !other.contains(details) && !details.contains(other)) other.open = false;
            });
          } else {
            details.querySelectorAll('details[open]').forEach(child => { child.open = false; });
          }
          this.syncOutsideListener();
        });
      });
      listen(this, 'click', event => {
        if (event.target.closest('.reference-header__mobile-panel a')) this.closeAll();
      });
      this.breakpoint = matchMedia('(min-width: 1024px)');
      listen(this.breakpoint, 'change', () => this.closeAll());
      // A future cart drawer can dispatch this event with the actual Shopify cart object.
      listen(document, 'cart:updated', event => {
        const cart = event.detail?.cart;
        if (cart && Number.isInteger(cart.item_count) && cart.item_count >= 0) this.updateCount(cart.item_count);
      });
      // Read back real totals after browser history restoration; never poll in the background.
      listen(window, 'pageshow', event => { if (event.persisted) this.refreshCount(); });
    }
    closeAll() {
      this.disclosures?.forEach(details => { details.open = false; });
      this.outsideController?.abort();
      this.outsideController = null;
    }
    syncOutsideListener() {
      this.outsideController?.abort();
      this.outsideController = null;
      if (!this.isConnected || !this.disclosures.some(details => details.open)) return;
      this.outsideController = new AbortController();
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, {signal: this.outsideController.signal});
    }
    updateCount(count) {
      const badge = this.querySelector('[data-header-cart-count]');
      const spoken = this.querySelector('[data-header-cart-total]');
      if (badge) { badge.textContent = count > 99 ? '99+' : String(count); badge.hidden = count === 0; }
      if (spoken) spoken.textContent = String(count);
    }
    async refreshCount() {
      if (!this.dataset.cartUrl) return;
      try {
        const response = await fetch(this.dataset.cartUrl, {headers:{Accept:'application/json'}, signal:this.controller.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (Number.isInteger(cart.item_count) && cart.item_count >= 0) this.updateCount(cart.item_count);
      } catch { /* Preserve the server-rendered count when a read fails. */ }
    }
    disconnectedCallback() {
      this.closeAll();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
